import { getCart } from '@/api/cart'
import { getuserInfo, setOrder } from '@/utils/auth'
const state = {
  cartProducts: [],
  orderNumber: null,
}

const getters = {
  
  totalCount(state){
    return state.cartProducts.reduce((sum,prod) => sum + prod.count, 0)
  },
  totalCounts(state){
    return state.cartProducts.reduce((sum,prod) => sum + prod.counts, 0)
  },
  totalPrice(){
    return state.cartProducts.reduce((sum, prod) => sum + Number(prod.prices), 0).toFixed(2)
  },
  checkedCount(state){
    return state.cartProducts.reduce(
      (sum, prod) => {
        if (prod.isChecked) {
          sum += prod.count
        }
        return sum
      }, 0)
  },
  checkedPrice(){
    return state.cartProducts.reduce(
      (sum, prod) => {
        if (prod.isChecked) {
          sum += Number(prod.prices)
        }
        return sum
      }, 0).toFixed(2)
  }
}

const mutations = {

  SET_Ordernumber: (state, data) => {
    
    let projectTime = parseInt(new Date().getTime() / 1000)
    let phone = getuserInfo().slice(-5)
    let prods1 = data.length
    const ordernumbers =  projectTime + '0' + phone + prods1 + Math.floor(Math.random() * 100)
    state.orderNumber = ordernumbers
  },

  SET_CART: (state, cartList) => {
    state.cartProducts = cartList
  },
  
  updateAllProductChecked(state,checked) {
    state.cartProducts.forEach(prod => {
      prod.isChecked = checked
    });
  },
  updateProductChecked(state, {
    checked,
    prodId
  }){
    const prod = state.cartProducts.find(item => item.newpid === prodId)
    prod && (prod.isChecked = checked)
  },
}

const actions = {
  getFromCart({ commit }) {
    return new Promise((resolve,reject) => {
      getCart().then(
        res => {
          const data = JSON.parse(res.data)
          commit('SET_CART',data)
          resolve()
        }
      ).catch(error =>{
        reject(error)
      })
    })
  },
  addToOrder({ commit }, data) {
    return new Promise(resolve => {
      commit('SET_Ordernumber', data)
      data.forEach(item => {
        item.oid = state.orderNumber
      })
      setOrder(JSON.stringify(data))              // 转化为字符串
      resolve()
    })
  }

}

export default{
  namespaced: true,
  getters,
  state,
  mutations,
  actions
}





// WEBPACK FOOTER //
// ./src/store/modules/cart.js